// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorPage_wrapper__1th2I","helper":"ErrorPage_helper__2_iHB"};